export const GoogleIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.987"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.4617 1.39272C10.4133 1.28641 10.9763 1.28641 11.9988 1.39272C13.8086 1.6606 15.4864 2.49717 16.7894 3.78147C15.9089 4.61378 15.0399 5.45823 14.1828 6.3146C12.5413 4.92335 10.709 4.60222 8.68602 5.35122C7.20202 6.03372 6.16864 7.13972 5.58589 8.66922C4.63359 7.96025 3.6937 7.23477 2.76664 6.4931C2.70221 6.45919 2.62863 6.44677 2.55664 6.45766C4.02927 3.61828 6.33052 1.92954 9.46039 1.39141"
      fill="#F44336"
    />
    <path
      opacity="0.997"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.55397 6.4578C2.62834 6.44642 2.69878 6.45824 2.76528 6.49324C3.69234 7.2349 4.63223 7.96039 5.58453 8.66936C5.43468 9.26531 5.34021 9.87384 5.30234 10.4872C5.33472 11.0804 5.42878 11.6627 5.58453 12.2341L2.62484 14.59C1.33597 11.8968 1.31234 9.18605 2.55397 6.4578Z"
      fill="#FFC107"
    />
    <path
      opacity="0.999"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6491 17.4433C15.7275 16.6306 14.7628 15.8682 13.759 15.1596C14.7652 14.4491 15.376 13.4743 15.5912 12.2353H10.6602V8.81102C13.5039 8.7874 16.3463 8.81146 19.1875 8.88321C19.7265 11.8101 19.1039 14.4491 17.3198 16.8002C17.1076 17.0257 16.8829 17.2404 16.6491 17.4433Z"
      fill="#448AFF"
    />
    <path
      opacity="0.993"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.58469 12.2354C6.66094 14.9102 8.63406 16.1589 11.5041 15.9812C12.3097 15.888 13.0821 15.6065 13.7589 15.1596C14.7634 15.8701 15.7268 16.6314 16.6491 17.4434C15.1878 18.7564 13.3246 19.5356 11.3636 19.6536C10.9181 19.6892 10.4704 19.6892 10.0249 19.6536C6.68412 19.2599 4.2175 17.572 2.625 14.59L5.58469 12.2354Z"
      fill="#43A047"
    />
  </svg>
);
export const orangetick=<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
  <path d="M14 1L4.9 12L1 7.875" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
export const ChatIcon = (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.8 10.64V4.75H2C0.9 4.75 0 5.605 0 6.65V12.35C0 13.395 0.9 14.25 2 14.25H3V17.1L6 14.25H11C12.1 14.25 13 13.395 13 12.35V10.621C12.9342 10.634 12.8672 10.6407 12.8 10.6409H5.8V10.64ZM18 0H9C7.9 0 7 0.855 7 1.9V9.5H14L17 12.35V9.5H18C19.1 9.5 20 8.64595 20 7.6V1.9C20 0.855 19.1 0 18 0Z"
      fill="#1D2951"
    />
  </svg>
);

export const alertIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 29.3334C23.3638 29.3334 29.3334 23.3638 29.3334 16C29.3334 8.63622 23.3638 2.66669 16 2.66669C8.63622 2.66669 2.66669 8.63622 2.66669 16C2.66669 23.3638 8.63622 29.3334 16 29.3334Z"
      stroke="#EA580C"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 10.6667V16"
      stroke="#EA580C"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 21.3333H16.0133"
      stroke="#EA580C"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
